import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import Moment from "moment";
import { useGetUserNotificationsQuery } from "../../../redux/exchangeUniApi";
import { setNotifications } from "../../../redux/notificationsSlice";
const NotificationLogs = ({ manageScreenSize }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const userData = useSelector((state) => state?.user?.userData);
  const { data } = useGetUserNotificationsQuery(userData?.id);
  const notifications = useSelector((state) => state.notifications);
  console.log(notifications, "notifications");

  useEffect(() => {
    if (data) {
      console.log(data, "notifications2");
      dispatch(setNotifications(data));
    }
  }, [data]);

  return (
    <div
      className={
        manageScreenSize === "tv_chart_container2-zero"
          ? "trading_table-f"
          : "trading_table mt-3"
      }
    >
      <table className="table">
        <thead>
          <tr>
            <th>{t("Time")}</th>
            <th>{t("Title")}</th>
            <th>{t("Message")}</th>
          </tr>
        </thead>
        <tbody>
          {notifications.length > 0 ? (
            notifications.map((item) => (
              <tr>
                <td>{Moment(item.created_at).format("lll")}</td>
                <td>{item.title}</td>
                <td>{item.message}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={4}>No Records found!</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default NotificationLogs;
